/* unplugin-vue-components disabled */import { render } from "./materialCard.vue?vue&type=template&id=f8e25328&scoped=true"
import script from "./materialCard.vue?vue&type=script&lang=js"
export * from "./materialCard.vue?vue&type=script&lang=js"

import "./materialCard.vue?vue&type=style&index=0&id=f8e25328&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上电-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8e25328"]])

export default __exports__